import { IChecklistDictionary } from 'APIPackage/DictionariesModule/interfaces/IChecklistDictionary';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryChecklistSelectOption = makeCreateDictionarySelectOption<IChecklistDictionary>(
  'id',
  'title',
);
